import React, { useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { approveOrRejectRegisteredUser, fetchRegisteredUsers } from "../../store/thunks/registrations";
import { TOAST_STATE_DANGER, USER_STATUS } from "../../utils/constants";
import { showToast } from "../../store/thunks/toasts";
import { useIntl } from "react-intl";
import Button from "../DesignSystem/Button/Button";
import CustomInput from "../DesignSystem/CustomInput/CustomInput";

const RejectRequestPopup = ({ id, firstName, lastName, onFinish, onClose }) => {
	const dispatch = useDispatch();
	const { formatMessage } = useIntl();

	const [rejectReason, setRejectReason] = useState("");
	const rejectReasonInput = useRef();

	const handleReasonChange = () => {
		setRejectReason(rejectReasonInput.current.value);
	};

	const onConfirmRejectRequest = async () => {
		const payload = {
			updates: [
				{
					id: id,
					approvalStatus: USER_STATUS.REJECTED,
					reason: rejectReason,
				},
			],
		};

		const approveUserResponse = await dispatch(approveOrRejectRegisteredUser(payload));
		if (approveUserResponse) {
			dispatch(
				showToast({
					message: "registration.reject.success",
				})
			);
			await dispatch(fetchRegisteredUsers());
		} else {
			dispatch(
				showToast({
					message: "registration.approval.error",
					type: TOAST_STATE_DANGER,
				})
			);
		}
		onFinish();
	};

	return (
		<div className="user-details flex direction-col align-items-start">
			<div className="text text-header--7 text-left">
				{formatMessage({ id: "registration.request.reject.title" })}
			</div>

			<div className="text text-body--3 text-left mt-8">
				{formatMessage({ id: "registration.request.reject.description" }, { name: `${firstName} ${lastName}` })}
			</div>

			<div className="row mt-16">
				<div className="col-lg-12">
					<CustomInput
						id="rejectReason"
						label="registration.reason"
						placeholder="registration.reason.placeholder"
						ref={rejectReasonInput}
						onChange={handleReasonChange}
					/>
				</div>
			</div>

			<div className="flex direction-row align-items-center justify-content-end mt-16">
				<Button className="button-tertiary" label="registration.actions.cancel" onClick={onClose} />
				<Button
					className="button-primary button-danger ml-8"
					label="registration.actions.confirm"
					onClick={onConfirmRejectRequest}
				/>
			</div>
		</div>
	);
};

export default connect(
	(state) => ({
		...state.registrations,
	}),
	{ approveOrRejectRegisteredUser, fetchRegisteredUsers }
)(RejectRequestPopup);
